import { makeStyles } from '@material-ui/core';

export const historicoSituacaoVendaStyles = makeStyles({
  iconeVendaAprovada: {
    color: '#43a047',
  },
  iconeOrcamentoRecusado: {
    color: '#f44336',
  },
  iconeEmOrcamento: {
    color: '#5890aa',
    transform: 'rotate(45deg)',
  },
});
